import { use, useEffect } from 'react';

import { BackendConfigContext, type BackendConfigJson } from '../utils';

function getEnvironmentPrefix(stage: BackendConfigJson['Stage']) {
  if (stage === 'prod') {
    return '';
  }

  return `[${stage.toUpperCase()}] `;
}

function getTitlePart(title: string | undefined) {
  if (title) {
    return `${title} | `;
  }

  return ``;
}

export function usePageTitle(title: string | undefined) {
  const backendConfig = use(BackendConfigContext);

  useEffect(() => {
    document.title = `${getEnvironmentPrefix(backendConfig.Stage)}${getTitlePart(title)}Viva Planung`;
  }, [title, backendConfig.Stage]);
}
